import { Sun, Moon } from "lucide-react";
import { Button } from "./ui/button";
import { useTheme } from "../contexts/ThemeContext";

// NB: Denne fil undgår bevidst ternary-JSX (`<A/> : <B/>`) og hook-values
// direkte i JSX-props for at undgå at Emergent's visual-edits
// babel-metadata-plugin crasher under prop-trace.
// Se test_reports/iteration_103.json + brugerens screenshot fra 19/08-2026 for RCA.
function IconFor(props) {
  if (props.isPrint) return <Moon className="h-4 w-4" />;
  return <Sun className="h-4 w-4" />;
}

export default function ThemeToggle(props) {
  const size = props.size || "sm";
  const theme = useTheme();
  const printMode = !!theme.printMode;
  const handleClick = theme.togglePrintMode;
  const variant = printMode ? "default" : "outline";
  const title = printMode
    ? "Skift til mørk tilstand"
    : "Skift til lys tilstand (print)";
  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      data-testid="theme-toggle-btn"
      title={title}
    >
      <IconFor isPrint={printMode} />
    </Button>
  );
}
